<template>
    <div id="hello">
        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
        </div>

        <div id="content">
            <h1 id="main-title">
                <img src="../assets/img/ramka.png">
                <span><span>WYBIERZ LOKAL USŁUGOWY</span></span>
            </h1>
            <div id="render1-wrapper">
                <Render1 v-on:chooseLevel="chooseLevel" v-bind:chosenLevel="chosenLevel" v-bind:page="'locals'"></Render1>
            </div>
            <div id="flatplan-wrapper">
                <Localplan v-on:chooseLocal="chooseLocal"  v-bind:chosenLevel="chosenLevel"  v-bind:chosenLocal="chosenLocal"></Localplan>
            </div>
            <section class="section no-padding-top">
                <div class="container  is-fluid" id="localList">
                    <div class="columns">
                        <div class="column is-full">
                            <div class="filters">
                                <p class="has-text-centered">Piętro:
                                    <span style="max-width: 500px; display: block; margin: auto; text-align: center;"><v-select :options="localLevels" v-model="chosenLevel" :searchable="false"></v-select></span>
                                </p>

                            </div>
                            <p>
                                <a @click="reset()" id="reset-btn" :class="{active : (chosenLevel || chosenLocal || minArea || maxArea)}">wyczyść filtry</a>
                            </p>
                            <h2>KATALOG LOKALI USŁUGOWYCH</h2>
                            <div class="table-wrapper">
                            <table class="table is-striped" id="loc-table">
                                <tr>
                                    <th>Piętro</th>
                                    <th>Numer Lokalu Usługowego</th>
                                    <th>Metraż</th>

                                    <th>Karta Lokalu Usługowego</th>
                                </tr>
                                <tbody>
                                 <tr v-for="(local, i) in processedLocals" :key="i">
                                    <td class="flevel"
                                        :rowspan="local.count"
                                        v-if="isSame(local, i, filteredLocals)"

                                    ><div class="vertical">{{local.pietro}}</div></td>
                                    <td>{{local.numer}}</td>
                                    <td><span v-html="$options.filters.metrify(local.metraz)"></span></td>

                                    <td><a :href="'../___lokale___/'+local.numer+'.pdf'" class="view-plan" target="_blank">Zobacz plan</a></td>

                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import Render from "../components/Render";
    import Render1 from "../components/Render1";
    import isSame from '../assets/js/common.js';
    import anime from 'animejs/lib/anime.es.js';
    import Vue from 'vue';
    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    import 'vue-select/dist/vue-select.css';
    import Localplan from "../components/Localplan";


    var levels = [];
    levels[0] = 'PARTER';
    levels[1] = 'I PIĘTRO';
    levels[2] = 'II PIĘTRO';
    levels[3] = 'III PIĘTRO';
    levels[4] = 'IV PIĘTRO (PODDASZE)';

    export default {
        name: 'Locals',
        data() {
            return {
                isDay: false,
                minArea: "",
                maxArea: "",
                chosenLocal: '',
                chosenLevel: '',

                locals: [
                    {
                        "numer": "U1",
                        "metraz": "58,32",
                        "pietro": "PARTER"
                    }
                ]
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            },

            reset() {
                this.chosenLocal = "";
                this.chosenLevel = "";
                this.minArea = "";
                this.maxArea = "";
            },

            chooseLevel(number) {
                this.chosenLevel = levels[number];
                this.chosenLocal = '';
                console.log(number);
                this.scroll({
                    to: '#localplan'
                });
            },

            chooseLocal(number) {
              this.chosenLocal = number;
                this.scroll({
                    to: '#localList'
                });
            },

            isSame : isSame,

            scroll(arg) {
                let el = document.querySelector(arg.to),
                    offset = parseInt(arg.offset) || 0,
                    duration = arg.duration || 800,
                    easing = arg.easing || 'easeOutExpo',
                    callback = arg.callback || null;

                if ( el ) {
                    anime({
                        targets: ['html', 'body'],
                        scrollTop: (el.offsetTop - offset),
                        duration: duration,
                        easing: easing,
                        complete: callback
                    })
                        .finished.then(() => {

                    });
                }
            }


        },
        filters: {
            metrify : function (value) {
                if (!value) { return '&ndash;'; }

                return value + '&nbsp;m<sup>2</sup>';
            }
        },

        computed: {
            filteredLocals : function() {
                var locals = this.locals;


                if(this.minArea) {
                    var minArea = this.minArea;
                    locals = locals.filter(function(local){
                        return  Number(local.metraz.replace(/,/g, '.')) >= Number(minArea.replace(/,/g, '.'));
                    });
                }

                if(this.maxArea) {
                    var maxArea = this.maxArea;
                    locals = locals.filter(function(local){
                        return Number(local.metraz.replace(/,/g, '.')) <= Number(maxArea.replace(/,/g, '.'));
                    });
                }

                if(this.chosenLocal) {
                    var chosenLocal = this.chosenLocal;
                    locals = locals.filter(function(local){
                        return local.numer === chosenLocal;
                    });
                }
                return locals;
            },

            processedLocals: function () {
                var locals = this.filteredLocals;
                locals = locals.map(function(local) {
                    var level = local.pietro;
                    var filtered = locals.filter(function(local){
                        return local.pietro === level;
                    });
                    local.count = filtered.length;
                    return local;
                });

                return locals;
            },

            localLevels: function() {
                return [...new Set( this.locals.map(local => local.pietro))];
            },

            localNumbers: function() {
                return [...new Set( this.locals.map(local => local.numer))];
            },
        },

        components: {
            Render: Render,
            Render1: Render1,
            Localplan: Localplan
        }



    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
